import type { Formation, GameMode, LineupSlot } from "./types";

const slots433: LineupSlot[] = [
  { id: "gk", label: "POR", role: "POR", positionTags: ["portiere"] },
  { id: "lb", label: "TS", role: "DIF", positionTags: ["terzino", "quinto"] },
  { id: "cb1", label: "DC", role: "DIF", positionTags: ["centrale", "braccetto"] },
  { id: "cb2", label: "DC", role: "DIF", positionTags: ["centrale", "braccetto"] },
  { id: "rb", label: "TD", role: "DIF", positionTags: ["terzino", "quinto"] },
  { id: "cm1", label: "Mezzala sx", role: "CEN", positionTags: ["mezzala", "mediano"] },
  { id: "regista", label: "Regista", role: "CEN", positionTags: ["regista", "mediano"] },
  { id: "cm2", label: "Mezzala dx", role: "CEN", positionTags: ["mezzala", "mediano"] },
  { id: "lw", label: "Ala sinistra", role: "ATT", positionTags: ["ala", "esterno", "seconda-punta"] },
  { id: "st", label: "Centravanti", role: "ATT", positionTags: ["centravanti", "seconda-punta"] },
  { id: "rw", label: "Ala destra", role: "ATT", positionTags: ["ala", "esterno", "seconda-punta"] },
];

const slots4312: LineupSlot[] = [
  { id: "gk", label: "POR", role: "POR", positionTags: ["portiere"] },
  { id: "lb", label: "TS", role: "DIF", positionTags: ["terzino", "quinto"] },
  { id: "cb1", label: "DC", role: "DIF", positionTags: ["centrale", "braccetto"] },
  { id: "cb2", label: "DC", role: "DIF", positionTags: ["centrale", "braccetto"] },
  { id: "rb", label: "TD", role: "DIF", positionTags: ["terzino", "quinto"] },
  { id: "cm1", label: "Mezzala sx", role: "CEN", positionTags: ["mezzala", "mediano"] },
  { id: "regista", label: "Regista", role: "CEN", positionTags: ["regista", "mediano"] },
  { id: "cm2", label: "Mezzala dx", role: "CEN", positionTags: ["mezzala", "mediano"] },
  { id: "trequartista", label: "Trequartista", role: "CEN", positionTags: ["trequartista", "seconda-punta"] },
  { id: "st1", label: "Punta sx", role: "ATT", positionTags: ["seconda-punta", "centravanti", "trequartista"] },
  { id: "st2", label: "Punta dx", role: "ATT", positionTags: ["seconda-punta", "centravanti", "trequartista"] },
];

const slots442: LineupSlot[] = [
  { id: "gk", label: "POR", role: "POR", positionTags: ["portiere"] },
  { id: "lb", label: "TS", role: "DIF", positionTags: ["terzino", "quinto"] },
  { id: "cb1", label: "DC", role: "DIF", positionTags: ["centrale", "braccetto"] },
  { id: "cb2", label: "DC", role: "DIF", positionTags: ["centrale", "braccetto"] },
  { id: "rb", label: "TD", role: "DIF", positionTags: ["terzino", "quinto"] },
  { id: "lm", label: "Esterno sx", role: "CEN", positionTags: ["esterno", "quinto", "ala"] },
  { id: "cm1", label: "Mediano sx", role: "CEN", positionTags: ["mediano", "mezzala", "regista"] },
  { id: "cm2", label: "Mediano dx", role: "CEN", positionTags: ["mediano", "mezzala", "regista"] },
  { id: "rm", label: "Esterno dx", role: "CEN", positionTags: ["esterno", "quinto", "ala"] },
  { id: "st1", label: "Punta sx", role: "ATT", positionTags: ["seconda-punta", "centravanti", "trequartista"] },
  { id: "st2", label: "Punta dx", role: "ATT", positionTags: ["seconda-punta", "centravanti", "trequartista"] },
];

const slots352: LineupSlot[] = [
  { id: "gk", label: "POR", role: "POR", positionTags: ["portiere"] },
  { id: "lcb", label: "Braccetto sx", role: "DIF", positionTags: ["braccetto", "centrale", "terzino"] },
  { id: "cb", label: "DC", role: "DIF", positionTags: ["centrale", "braccetto"] },
  { id: "rcb", label: "Braccetto dx", role: "DIF", positionTags: ["braccetto", "centrale", "terzino"] },
  { id: "lwb", label: "Quinto sx", role: "CEN", positionTags: ["quinto", "esterno", "terzino"] },
  { id: "cm1", label: "Mezzala sx", role: "CEN", positionTags: ["mezzala", "mediano"] },
  { id: "regista", label: "Regista", role: "CEN", positionTags: ["regista", "mediano"] },
  { id: "cm2", label: "Mezzala dx", role: "CEN", positionTags: ["mezzala", "mediano"] },
  { id: "rwb", label: "Quinto dx", role: "CEN", positionTags: ["quinto", "esterno", "terzino"] },
  { id: "st1", label: "Punta sx", role: "ATT", positionTags: ["seconda-punta", "centravanti", "trequartista"] },
  { id: "st2", label: "Punta dx", role: "ATT", positionTags: ["seconda-punta", "centravanti", "trequartista"] },
];

const slots4321: LineupSlot[] = [
  { id: "gk", label: "POR", role: "POR", positionTags: ["portiere"] },
  { id: "lb", label: "TS", role: "DIF", positionTags: ["terzino", "quinto"] },
  { id: "cb1", label: "DC", role: "DIF", positionTags: ["centrale", "braccetto"] },
  { id: "cb2", label: "DC", role: "DIF", positionTags: ["centrale", "braccetto"] },
  { id: "rb", label: "TD", role: "DIF", positionTags: ["terzino", "quinto"] },
  { id: "cm1", label: "Mezzala sx", role: "CEN", positionTags: ["mezzala", "mediano"] },
  { id: "regista", label: "Regista", role: "CEN", positionTags: ["regista", "mediano"] },
  { id: "cm2", label: "Mezzala dx", role: "CEN", positionTags: ["mezzala", "mediano"] },
  { id: "am1", label: "Rifinitore sx", role: "CEN", positionTags: ["trequartista", "seconda-punta", "ala"] },
  { id: "am2", label: "Rifinitore dx", role: "CEN", positionTags: ["trequartista", "seconda-punta", "ala"] },
  { id: "st", label: "Centravanti", role: "ATT", positionTags: ["centravanti", "seconda-punta"] },
];

const slots4231: LineupSlot[] = [
  { id: "gk", label: "POR", role: "POR", positionTags: ["portiere"] },
  { id: "lb", label: "TS", role: "DIF", positionTags: ["terzino", "quinto"] },
  { id: "cb1", label: "DC", role: "DIF", positionTags: ["centrale", "braccetto"] },
  { id: "cb2", label: "DC", role: "DIF", positionTags: ["centrale", "braccetto"] },
  { id: "rb", label: "TD", role: "DIF", positionTags: ["terzino", "quinto"] },
  { id: "dm1", label: "Mediano sx", role: "CEN", positionTags: ["mediano", "regista"] },
  { id: "dm2", label: "Mediano dx", role: "CEN", positionTags: ["mediano", "regista"] },
  { id: "am1", label: "Trequartista sx", role: "CEN", positionTags: ["trequartista", "ala", "seconda-punta"] },
  { id: "trequartista", label: "Trequartista", role: "CEN", positionTags: ["trequartista", "seconda-punta"] },
  { id: "am2", label: "Trequartista dx", role: "CEN", positionTags: ["trequartista", "ala", "seconda-punta"] },
  { id: "st", label: "Centravanti", role: "ATT", positionTags: ["centravanti", "seconda-punta"] },
];

export const formations: Formation[] = [
  {
    id: "433",
    name: "4-3-3",
    shortName: "4-3-3",
    description: "Ali larghe, regista e centravanti: la forma piu arcade.",
    slots: slots433,
  },
  {
    id: "4312",
    name: "4-3-1-2",
    shortName: "4-3-1-2",
    description: "Trequartista libero dietro due punte: puro amarcord Serie A.",
    slots: slots4312,
  },
  {
    id: "442",
    name: "4-4-2",
    shortName: "4-4-2",
    description: "Due punte, fasce vere e centrocampo operaio.",
    slots: slots442,
  },
  {
    id: "352",
    name: "3-5-2",
    shortName: "3-5-2",
    description: "Tre centrali, quinti aggressivi e due punte: manuale Serie A.",
    slots: slots352,
  },
  {
    id: "4321",
    name: "4-3-2-1",
    shortName: "4-3-2-1",
    description: "Albero di Natale con due rifinitori dietro il centravanti.",
    slots: slots4321,
  },
  {
    id: "4231",
    name: "4-2-3-1",
    shortName: "4-2-3-1",
    description: "Doppio mediano, tre creatori e una punta: sfida moderna.",
    slots: slots4231,
  },
];

export const defaultFormationId = "4312";
export const lineupSlots: LineupSlot[] = slots433;

export const modes: GameMode[] = [
  {
    id: "draft",
    name: "Draft Moderno",
    shortName: "Draft",
    description: "Draft moderno facile: post-2010, ruoli mobili e spazio per sperimentare senza vincoli duri.",
    clubs: ["Juventus", "Milan", "Inter", "Napoli", "Roma", "Lazio", "Parma", "Sampdoria", "Atalanta", "Fiorentina", "Palermo", "Udinese", "Bologna", "Torino"],
    eras: ["anni2010", "moderna"],
    tone: "Stelle recenti, scouting moderno e incroci liberi senza vincoli di club.",
  },
  {
    id: "draft-hard",
    name: "Draft Moderno Difficile",
    shortName: "Difficile",
    description: "Stesso pool post-2010, ma ruoli fissi, almeno cinque club e niente XI costruite solo coi nomi piu ovvi.",
    clubs: ["Juventus", "Milan", "Inter", "Napoli", "Roma", "Lazio", "Parma", "Sampdoria", "Atalanta", "Fiorentina", "Palermo", "Udinese", "Bologna", "Torino"],
    eras: ["anni2010", "moderna"],
    tone: "La Serie A recente in versione expert: equilibrio, lavoro sporco e scelte meno automatiche.",
    locksRoles: true,
  },
  {
    id: "nostalgia",
    name: "Notti Nostalgia",
    shortName: "Nostalgia",
    description: "Prompt anni 70, 80, 90 e pochi 2000 cult con leggende, grandi provinciali e scudetti iconici.",
    clubs: ["Cagliari", "Torino", "Verona", "Venezia", "Reggina", "Lecce", "Salernitana", "Empoli", "Foggia", "Perugia", "Vicenza", "Piacenza", "Brescia", "Bari", "Chievo", "Napoli", "Sampdoria", "Fiorentina", "Parma", "Palermo", "Bologna", "Udinese", "Lazio", "Roma", "Milan", "Inter", "Juventus"],
    eras: ["anni70", "anni80", "anni90", "anni2000"],
    tone: "Maglie larghe, numeri dieci, telecronache infinite e sigle viste su un televisore a tubo catodico.",
  },
  {
    id: "nostalgia-hard",
    name: "Notti Nostalgia Difficile",
    shortName: "Nostalgia",
    description: "Stesso archivio storico, ma ruoli fissi, piu stagioni obbligate e quasi niente scorciatoie anni 2000.",
    clubs: ["Cagliari", "Torino", "Verona", "Venezia", "Reggina", "Lecce", "Salernitana", "Empoli", "Foggia", "Perugia", "Vicenza", "Piacenza", "Brescia", "Bari", "Chievo", "Napoli", "Sampdoria", "Fiorentina", "Parma", "Palermo", "Bologna", "Udinese", "Lazio", "Roma", "Milan", "Inter", "Juventus"],
    eras: ["anni70", "anni80", "anni90", "anni2000"],
    tone: "Amarcord in versione dura: meno cameo comodi, piu epoche da incastrare.",
    locksRoles: true,
  },
];

export const eraLabels: Record<string, string> = {
  anni70: "Anni 70",
  anni80: "Anni 80",
  anni90: "Anni 90",
  anni2000: "Anni 2000",
  anni2010: "Anni 2010",
  moderna: "Era moderna",
};
